module.exports = __webpack_public_path__ + "static/img/kf.2db2660b.jpeg";